<template>
	<div class="tags-view-container">
		<el-scrollbar class="tags-view-wrapper">
			<router-link
				v-for="(tag, index) in $store.getters.tagsViewList"
				:key="tag.fullPath"
				class="tags-view-item"
				:class="isActive(tag) ? 'active' : ''"
				:style="{
					backgroundColor: isActive(tag) ? $store.getters.cssVar.menuBg : '',
					borderColor: isActive(tag) ? $store.getters.cssVar.menuBg : ''
				}"
				:to="{ path: tag.fullPath }"
				@click.native.stop="openMenu($event, index)"
			>
				<label>{{tag.title}}</label>
				<template v-if="!isAffiix(tag)">
					<i class="el-icon-close" @click.prevent.stop="onCloseClick(index,tag)"></i>
				</template>
			</router-link>
		</el-scrollbar>
		<context-menu
			v-show="visible"
			:style="menuStyle"
			:index="selectIndex"
		></context-menu>
	</div>
</template>

<style lang="scss" scoped>
.tags-view-container {
  border-bottom: 1px solid #d8dce5;
  width: 100%;
  height: 34px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .tags-view-item {
    display: inline-flex;
    position: relative;
    margin-left: 5px;
    margin-top: 4px;
    padding: 0 8px;
    border: 1px solid #d8dce5;
    height: 26px;
    background: #fff;
    cursor: pointer;
    line-height: 26px;
    font-size: 12px;
    color: #495060;
    align-items: center;
    justify-content: space-around;
    &:first-of-type {
      margin-left: 15px;
    }
    &:last-of-type {
      margin-right: 15px;
    }
    &.active {
      color: #fff;
      &::before {
        display: inline-block;
        position: relative;
        margin-right: 4px;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        background: #fff;
        content: '';
      }
    }

    // close 按钮
    .el-icon-close {
      border-radius: 50%;
      &::before {
        transform: scale(0.6);
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }

  }
}
</style>

<script>
import ContextMenu from "./ContextMenu";
export default {
    name:'TagsView',
    data() {
        return {
            // contextMenu 相关
            selectIndex: 0,
            visible: false,
            menuStyle: {
                left: 0,
	            top: 0
            }
        }
    },
    components: {
        ContextMenu
    },
    computed: {

    },
    watch: {
        visible: {
            handler(val) {
                // console.log('visible(val):', val)
                if (val) {
                    document.body.addEventListener("click", this.closeMenu);
                } else {
                    document.body.removeEventListener("click", this.closeMenu);
                }
            },
            immediate: true
        }
    },
    mounted() {
        // console.log('tagsViewList', this.$store.getters.tagsViewList);
    },
    methods: {
        /**
         * 是否被选中
         */
        isActive(tag) {
            return tag.path === this.$route.path;
        },
        isAffiix(tag) {
            return tag.meta&&tag.meta.closeFlag&&this.$store.getters.roles == '派遣员工'
        },
        /**
         * 展示 menu
         */
        openMenu(e, index) {
            if (this.$store.getters.currIndex != index) {
                this.$store.commit('setCurrIndex', index)
                return
            }
            if (this.$store.getters.roles == '派遣员工') {
                return 
            }
            const { x, y } = e;
            this.menuStyle.left = x + "px";
            this.menuStyle.top = y + "px";
            this.selectIndex = index;
            this.visible = true;
        },     
        /**
         * 关闭 tag 的点击事件
         */
        onCloseClick(index, tag) {
            this.$store.commit("removeTagsView", {
                type: "index",
                index
            });
            // 如果删除的是当前页面，自动定位到上一个页面
            if (this.isActive(tag)) {
                const tagsViewList = this.$store.getters.tagsViewList;
                if (index == 0 && tagsViewList.length >= 1) {
                    const pre_index = 0;
                    const pre_page = tagsViewList[pre_index];
                    this.$router.push(pre_page.fullPath);
                } else if (tagsViewList.length == 0) { // 如果是最后一个，定位到首页
                    this.$router.push("/");
                } else {
                    const pre_index = index - 1;
                    const pre_page = tagsViewList[pre_index];
                    this.$router.push(pre_page.fullPath);
                }
            }
        },
        /**
         * 关闭 menu
         */
        closeMenu (){
            this.visible = false;
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/views/layout/components/TagsView/index.vue